module.exports = __webpack_public_path__ + "img/Just_Eat-Logo.f9041299.svg";